import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from "react";
import { useTranslation } from "@madmedical/i18n";
import { extractSelected } from "../utils";
import Button from "../../../atoms/Button";
import ActionSheet from "../../../molecules/ActionSheet";
import { usePatientMeasurements } from "../../../providers/patientMeasurements";
import MobileFilterList from "./MobileFilterList";
const emptySelected = {
    patients: [],
    metricTypes: [],
    alertLevels: [],
};
const PatientMeasurementsMobileFilter = () => {
    const { filterChoices, onFilterChange } = usePatientMeasurements();
    const actionSheetRef = useRef(null);
    const [selected, setSelected] = useState({
        patients: extractSelected(filterChoices, "patients"),
        metricTypes: extractSelected(filterChoices, "metricTypes"),
        alertLevels: extractSelected(filterChoices, "alertLevels"),
    });
    const { t } = useTranslation();
    const handleTogglePress = () => {
        var _a;
        (_a = actionSheetRef.current) === null || _a === void 0 ? void 0 : _a.toggle();
    };
    const handleResetPress = () => {
        setSelected(emptySelected);
    };
    const handleSubmitPress = () => {
        var _a;
        onFilterChange === null || onFilterChange === void 0 ? void 0 : onFilterChange("patients", selected.patients);
        onFilterChange === null || onFilterChange === void 0 ? void 0 : onFilterChange("metricTypes", selected.metricTypes);
        onFilterChange === null || onFilterChange === void 0 ? void 0 : onFilterChange("alertLevels", selected.alertLevels);
        (_a = actionSheetRef.current) === null || _a === void 0 ? void 0 : _a.toggle();
    };
    const handleChange = (filterKey) => (newSelected) => {
        setSelected((prevSelected) => (Object.assign(Object.assign({}, prevSelected), { [filterKey]: newSelected })));
    };
    return (_jsxs(_Fragment, { children: [_jsx(ActionSheet, Object.assign({ title: t("filter"), footer: _jsx(Button, Object.assign({ onPress: handleSubmitPress, size: "xl" }, { children: t("showResults") })), rightContent: _jsx(Button, Object.assign({ position: "absolute", right: 0, top: 0, onPress: handleResetPress, size: "xs", variant: "link", p: 0 }, { children: t("setback") })), ref: actionSheetRef }, { children: _jsxs(_Fragment, { children: [_jsx(MobileFilterList, { filterChoices: filterChoices.metricTypes, selected: selected.metricTypes, isMultiSelect: true, title: t("measures:type"), onChange: handleChange("metricTypes") }), _jsx(MobileFilterList, { filterChoices: filterChoices.alertLevels, selected: selected.alertLevels, isMultiSelect: false, title: t("alertLevel"), onChange: handleChange("alertLevels") }), _jsx(MobileFilterList, { filterChoices: filterChoices.patients, selected: selected.patients, isMultiSelect: true, title: t("patients"), onChange: handleChange("patients") })] }) })), _jsx(Button, Object.assign({ variant: "outlined", size: "xs", onPress: handleTogglePress, leftIconName: "filter" }, { children: t("filter") }))] }));
};
export default PatientMeasurementsMobileFilter;
